// extracted by mini-css-extract-plugin
export default {"changeLink":"pP-z","disabled":"qP-z","inline":"rP-z"};